import baseApi from 'shared/api/baseApi';

import type { AgentCase, CasesListParams, CasesListResponse, UpdateCaseBody } from '../model/case';
import type { ConversationImportPreview } from '../model/conversationImport';

const casesApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getCases: build.query<CasesListResponse, CasesListParams>({
      query: ({ projectId, status, page, limit }) => ({
        url: '/admin/agentCases',
        method: 'GET',
        params: {
          projectId,
          page,
          limit,
          ...(status ? { status } : {}),
        },
      }),
      providesTags: [{ type: 'AgentCases', id: 'LIST' }],
    }),
    getCaseConversation: build.query<
      { conversation: ConversationImportPreview },
      { caseId: number; upToCaseMessage?: boolean }
    >({
      query: ({ caseId, upToCaseMessage }) => ({
        url: `/admin/agentCases/${caseId}/conversation`,
        method: 'GET',
        params: upToCaseMessage ? { upToCaseMessage: true } : undefined,
      }),
    }),
    updateCase: build.mutation<AgentCase, { caseId: number; body: UpdateCaseBody }>({
      query: ({ caseId, body }) => ({
        url: `/admin/agentCases/${caseId}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: [{ type: 'AgentCases', id: 'LIST' }],
    }),
  }),
  overrideExisting: false,
});

export const { useGetCasesQuery, useGetCaseConversationQuery, useLazyGetCaseConversationQuery, useUpdateCaseMutation } =
  casesApi;

export default casesApi;
